import { apiClient } from '@/lib/api/client'

export type SendCsatResult = {
  recipient_email: string
  sent_at: string | null
  expires_at: string | null
  resent: boolean
}

export async function sendCsatSurvey(ticketId: string | number): Promise<SendCsatResult> {
  const res = await apiClient.post<{ success?: boolean; message?: string; data?: SendCsatResult }>(
    `/tickets/${ticketId}/send-csat`,
  )
  const data = res.data?.data
  if (!data?.recipient_email) {
    throw new Error(res.data?.message ?? 'Failed to send CSAT survey')
  }
  return data
}
